module.exports = __webpack_public_path__ + "img/moren.d6ecf772.png";